module.exports = __webpack_public_path__ + "static/media/2-FLYNT.95302093.mp3";